<template>
  <!-- wrap -->
  <div class="sm_star">
    <!-- header -->
    <div class="sm_header">
      <h1>Forum</h1>
      <button class="back_btn mdc-button" tabindex="0" @click="$router.go(-1)" @keypress="$router.go(-1)">
        <i class="material-icons">arrow_back</i>
      </button>
      <button :disabled="isDisabled" class="upload_btn mdc-button" tabindex="0" @click="askForRegister" @keypress="askForRegister">
        <span>{{ $t("1456") }}</span>
      </button>
    </div>
    <!-- //header -->

    <!-- content -->
    <div class="sm_wrap">
      <div class="write_wrap">
        <!-- tag -->
        <div class="write_tag">
          <div class="tag_form">
            <button class="tag_btn mdc-button" type="button">{{ $t("1457") }}</button>
            <span v-for="(tag, i) in form.tags" :key="i" class="txt mgr-10"
                  style="background: #f4f5f6;padding: 2px 3px;font-size: 12px;color: var(--Primary);">
              {{ tag.name }}
              <span class="p-5 cursor-pointer" tabindex="0" @click="removeTag(i)" @keypress="removeTag(i)">x</span>
            </span>
            <input
                id="tagInput"
                :placeholder="$t('1457')"
                class="txt no-border t-body3 t-color-textfieldGuid"
                @keyup="searchTags($event.target.value)"
                @keyup.enter.native="createTags($event.target.value)"

            />
            <!-- <span class="txt">{{ $t("1457") }}</span> -->
          </div>
          <ul v-if="tags && tags.length" class="tag-ul">
            <li
                v-for="tag in tags"
                :key="tag.id"
                class="cursor-pointer" tabindex="0"
                @click="addTag(tag)" @keypress="addTag(tag)"
            >{{ tag.name }}
            </li>
          </ul>
          <p class="tag_tail">{{ $t("1458") }}</p>
        </div>

        <!-- write -->
        <div class="write_form">
          <textarea v-model="form.contents.body" :placeholder="$t('1460')"></textarea>

          <div v-for="(img, i) in form.contents.images" :key="i" class="post-img position-relative mgr-32 mgb-32">
            <img :alt="img.originalName" :src="img.resourceUri" class="b-radius4"/>
            <span class="remove-img remove-image-new position-absolute t-color-white" tabindex="0"
                  @click="form.contents.images.splice(i, 1)" @keypress="form.contents.images.splice(i, 1)"><img src="/images/close.svg"
                                                                                           style="width: 20px;}"/></span>
          </div>
          <div v-if="form.contents.video && form.contents.video.resourceUri"
               class="post-video position-relative mgr-32 mgb-32" style="width: 120px;">
            <video-player
                :options="{muted: true, language: 'en', playbackRates: [0.7, 1.0, 1.5, 2.0], sources: [{type: form.contents.video.contentType, src: form.contents.video.resourceUri }], height: 100, width:120}"
                :playsinline="true"
                class="video-player-box"
            />
            <span class="remove-img remove-image-new position-absolute t-color-white" tabindex="0"
                  @click="resetVideo" @keypress="resetVideo"><img src="/images/close.svg"
                                                                                           style="width: 20px;}"/></span>
          </div>
        </div>
        <!-- //write -->

        <div class="comment_box write">
          <div class="comment_area">
            <input
                id="commentFileUpload"
                :accept="allowExt()"
                class="d-none"
                type="file"
                @change="uploadFile"
            />
            <button class="picture_btn mdc-button" style="background: url(/images/picture_btn.png)  center no-repeat; background-size: 22px auto;" tabindex="0" type="button"
                    @click="openFileUpload(true)" @keypress="openFileUpload(true)">사진
              업로드
            </button>
            <button class="video_btn mdc-button" style="background: url(/images/video_btn.png)  center no-repeat; background-size: 22px auto;" tabindex="0" type="button"
                    @click="openFileUpload(false)" @keypress="openFileUpload(false)">영상 업로드
            </button>

            <!-- <p class="tail_txt cursor-pointer">{{ $t("1461") }}</p> -->
          </div>
        </div>
      </div>
    </div>
    <!-- //content -->
  </div>
  <!-- //wrap -->
</template>

<script>
import socialApi from "@/api/forumApi.js";

// require styles
import "video.js/dist/video-js.css";
import {videoPlayer} from "vue-video-player";
import _ from 'lodash'
import {MDCRipple} from '@material/ripple'

export default {
  components: {
    videoPlayer
  },
  data() {
    return {
      form: {
        category: null,
        status: null,
        boardType: null,
        notifyType: null,
        contents: {
          type: null,
          subject: null,
          body: null,
          linkName: null,
          linkUrl: null,
          images: [],
          video: {
            chunkCount: 0,
            contentType: null,
            duration: 0,
            height: 0,
            id: null,
            name: null,
            originalName: null,
            resourceUri: null,
            size: 0,
            subFileResourceUri: [],
            width: 0
          }
        },
        fixed: false,
        tags: []
      },
      tags: [],
      // check if upload is set ti image or video
      uploadTypeImg: true,
      isDisabled: false,
    };
  },
  beforeMount() {
    this.setDetail();
  },
  mounted() {
    this.setMaterialUi()
  },
  methods: {
    resetVideo() {
      this.form.contents.video = {
        chunkCount: 0,
        contentType: null,
        duration: 0,
        height: 0,
        id: null,
        name: null,
        originalName: null,
        resourceUri: null,
        size: 0,
        subFileResourceUri: [],
        width: 0
      };
    },
    uploadFile(evt) {
      if (!evt.target.files[0]) return;

      // validate video and/or audio
      if (!this.videoAudioSelected()) return;

      // check if image selected then count number of image selected
      if (!this.invalidCountImg()) return;

      // check if user try to add more than 1 video
      if (!this.invalidVideoCount()) return;

      this.$showLoading();
      socialApi
          .upload(evt.target.files[0])
          .then(response => {
            // check if user uploaded an image
            if (this.uploadTypeImg)
              this.form.contents.images.push(response.data.data[0]);
            else this.form.contents.video = response.data.data[0];

            this.$hideLoading();
          })
          .catch(err => {
            this.$hideLoading();
            this.$error({content: err.errMsg}).then(() => {
            });
          });
    },
    videoAudioSelected() {
      if (
          (this.uploadTypeImg &&
              this.form.contents.video &&
              this.form.contents.video.resourceUri) ||
          (!this.uploadTypeImg && this.form.contents.images.length)
      ) {
        this.$alert({
          // title: this.$t('72'),
          content: this.$t("1473"),
          accept: this.$t("1476")
        });
        return false;
      }
      return true;
    },
    invalidCountImg() {
      if (this.uploadTypeImg && this.form.contents.images.length >= 5) {
        this.$alert({
          // title: this.$t('72'),
          content: this.$t("1469"),
          accept: this.$t("1470")
        });
        return false;
      }
      return true;
    },
    invalidVideoCount() {
      if (
          !this.uploadTypeImg &&
          this.form.contents.video &&
          this.form.contents.video.resourceUri
      ) {
        this.$alert({
          content: this.$t("1471"),
          accept: this.$t("1472")
        });
        return false;
      }
      return true;
    },
    openFileUpload(allowImg) {
      this.uploadTypeImg = allowImg;
      setTimeout(() => {
        document.getElementById("commentFileUpload").click();
      }, 0);
    },
    allowExt() {
      return this.uploadTypeImg ? "image/jpeg,image/png" : "video/mp4";
    },
    register() {
      this.$showLoading();
      let action = this.form.id
          ? socialApi.updatePost(this.form.id, this.form)
          : socialApi.register(this.form);

      action
          .then(response => {
            this.$hideLoading();
            this.isDisabled = true;
            this.$router.push('/forum/' + response.data.data.id);
          })
          .catch(err => {
            this.$error({content: err.errMsg}).then(() => {
            });
          });
    },
    setDetail() {
      if (!this.$route.params.postId) return;

      this.$showLoading();
      socialApi
          .socialDetails(this.$route.params.postId)
          .then(response => {
            Object.assign(this.form, response.data.data);
            this.$hideLoading();
          })
          .catch(err => {
            this.$error({content: err.errMsg}).then(() => {
            });
          });
    },

    askForRegister() {
      // check if No content exists
      if (!this.form.contents.body) {
        // show alert
        this.$alert({
          //title: this.$t("72"), // 학습을 중단한 강의입니다.
          content: this.$t("1883"), // 환불 요청 또는 신청 취소하여 학습이 중단된 강의는 더 이상 학습하실 수 없습니다.
          accept: this.$t("1884") // 확인
        });
        return;
      }

      this.isDisabled = true;

      // check if add or update
      // if (this.form.id) {
      //   this.$confirm({
      //     // title: this.$t('72'),   // 학습을 중단한 강의입니다.
      //     content: this.$t("1450"), // 환불 요청 또는 신청 취소하여 학습이 중단된 강의는 더 이상 학습하실 수 없습니다.
      //     accept: this.$t("1451"), // 확인
      //     cancel: this.$t("1447") //'TODO-취소'
      //   })
      //     .then(() => {
      //       this.register();
      //     })
      //     .catch(() => {});
      // } else {
      this.register();
      // }
    },
    searchTags: _.throttle(function (str) {
      //console.log('I get fired every two seconds!')
      socialApi
          .searchTags(str.trim())
          .then(response => {
            this.tags = response.data.data;
            if (str.indexOf(' ') >= 0 && this.tags.length < 1) {
              socialApi
                  .createTags({name: str.trim()})
                  .then(response1 => {
                    let rs = response1.data.data;
                    ;
                    if (rs.id) {
                      this.searchTags(str);
                    }
                  })
                  .catch(err => {
                    this.$error({content: err.errMsg}).then(() => {
                    });
                  });
            }
            // if(this.tags.length < 1 ){
            //    str
            // }
          })
          .catch(err => {
            this.$error({content: err.errMsg}).then(() => {
            });
          });
    }, 2000),
    createTags(str) {
      alert(str)
    },
    // searchTags(str) {
    //   socialApi
    //     .searchTags(str.trim())
    //     .then(response => {
    //       this.tags = response.data.data;
    //     })
    //     .catch(err => {
    //       this.$error({ content: err.errMsg }).then(() => {});
    //     });
    // },
    addTag(tag) {
      this.form.tags.push(tag);
      this.tags = [];
      document.getElementById("tagInput").value = null;
    },
    removeTag(index) {
      this.form.tags.splice(index, 1);
    }
  },
  setMaterialUi() {
    const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function (el) {
      let button = new MDCRipple.attachTo(el)
      return button
    })
  },
};
</script>

<style scoped>
.post-img span {
  padding: 5px;
  /* border: 1px solid #c8c8c8; */
  cursor: pointer;
  background: var(--Iconinactive);
}

.remove-image-new {
  top: -11px;
  right: -11px;
  border-radius: 50%;
  width: 21px;
  height: 21px;
  background: var(--Iconinactive);
  display: flex;
  justify-content: center;
  align-items: center;
  border: 4px solid var(--DocumentWhite);
  color: var(--DocumentWhite);
  line-height: 0px;
}

html[dir="rtl"] .remove-image-new {
  left: -11px;
}

.post-img {
  width: 150px;
  display: inline-block;
}

.post-img img {
  width: 150px;
}


.d-none {
  display: none;
}

.tag-ul {
  position: absolute;
  z-index: 1;
  margin-left: 20px;
  width: 97%;
}

html[dir="rtl"] .tag-ul {
  margin-right: 20px;
}

.tag-ul li {
  background-color: #c8c8c8;
  padding: 10px;
  border-bottom-color: #000;
}

.p-5 {
  padding: 5px !important;
}


.cursor-pointer {
  cursor: pointer;
}

.no-border {
  border: none;
}

</style>
